import React from 'react'
import logo from '../assets/images/logo.png';
import msme from '../assets/images/msme.jpeg';
import { Link } from 'react-router-dom';
import { Email } from '../constant/constant';


const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <>
            <footer className="bg-black dark:bg-gray-900 w-full">
                <div className="mx-auto px-4 py-6 lg:py-8 sm:items-center max-w-screen-xl">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">

                        {/* Column 1 - Logo */}
                        <div className="flex justify-center">
                            <Link to="/" className="flex items-center">
                                <img src={logo} className="w-40 md:w-2/4" alt="ADSKI Logo" />
                            </Link>
                        </div>

                        {/* Column 2 - MSME Image */}
                        <div className="flex justify-center">
                            <Link to="/" className="flex items-center">
                                <img src={msme} className="w-40 md:w-2/4" alt="MSME Logo" />
                            </Link>
                        </div>

                        {/* Column 3 - All Links */}
                        <div className="grid grid-cols-3 gap-2 sm:gap-0 sm:grid-cols-3">
                            <div>
                                <ul className="text-white dark:text-gray-400 font-medium">
                                    <li className="mb-4"> <Link to="/" className="hover:underline">Home</Link> </li>
                                    <li> <Link to="/about" className="hover:underline">About Us</Link> </li> </ul>
                            </div>
                            <div>
                                <ul className="text-white dark:text-gray-400 font-medium">
                                    <li className="mb-4"> <Link to="/client" className="hover:underline">Clients</Link> </li>
                                    <li> <Link className="hover:underline" to="/contact">Contact Us</Link> </li>
                                </ul>
                            </div>
                            <div>
                                <ul className="text-white dark:text-gray-400 font-medium">
                                    <li className="mb-4"> <Link className="hover:underline" to="/privacy">Privacy Policy</Link> </li>
                                    {/* <li> <Link className="hover:underline">Terms & Conditions</Link> </li> */}
                                </ul>
                            </div>


                        </div>

                    </div>
                </div>


                <div className="sm:items-center max-w-screen-xl mx-auto" align="center">
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-6">
                        <div className="text-center">
                            <span className="text-sm text-white sm:text-center dark:text-gray-400">
                                © {currentYear}
                                <Link className="hover:underline"> ADSKI</Link> All Rights Reserved.
                            </span>
                        </div>
                        <div className="text-center">
                            <Link className="text-white dark:hover:text-white">{Email}</Link>
                        </div>

                        <div className="flex justify-center sm:justify-start mt-4 sm:mt-0">
                            <a href="https://www.facebook.com/people/AdSki/100092173782508/?rdid=aLOTIj5dp7Skq17T&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14x6RaTZgH%2F" className="text-gray-500 dark:hover:text-white mx-3" target='_blank' rel="noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="24" height="24" fill="white">
                                    <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06H293V6.26S259.43 0 225.36 0c-73.22 0-121.14 44.38-121.14 124.72V195.3H22.89V288h81.33v224h100.2V288z" />
                                </svg>
                                <span className="sr-only">Facebook page</span>
                            </a>

                            <a href="https://www.instagram.com/adski.in?igsh=MWN2YWV5bDcybWxkMA==" className="text-gray-500 dark:hover:text-white mx-3" target='_blank' rel="noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="24" height="24" fill="white">
                                    <path d="M224,202.66A53.34,53.34,0,1,0,277.34,256,53.38,53.38,0,0,0,224,202.66ZM224,284a28,28,0,1,1,28-28A28,28,0,0,1,224,284Zm85.33-136a12,12,0,1,0,12,12A12,12,0,0,0,309.33,148ZM224,112a144,144,0,1,0,144,144A144.16,144.16,0,0,0,224,112Zm0,264a120,120,0,1,1,120-120A120.13,120.13,0,0,1,224,376ZM398.8,100.2A48,48,0,0,0,360,64H88A48,48,0,0,0,49.2,100.2C40,124.8,40,160,40,224s0,99.2,9.2,123.8A48,48,0,0,0,88,448H360a48,48,0,0,0,38.8-100.2C408,323.2,408,288,408,224S408,124.8,398.8,100.2ZM384,360a24,24,0,0,1-24,24H88a24,24,0,0,1-24-24c-7.6-19.2-7.6-53.2-7.6-136S56.4,151.2,64,132A24,24,0,0,1,88,108H360a24,24,0,0,1,24,24c7.6,19.2,7.6,53.2,7.6,136S391.6,340.8,384,360Z" />
                                </svg>


                                <span className="sr-only">Instagram page</span>
                            </a>

                            <a href="https://www.linkedin.com/company/93169093/admin/dashboard/" className="text-gray-500 dark:hover:text-white mx-3" target='_blank' rel="noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="white">
                                    <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8h4v14h-4V8zm7.5 0h3.7v2.17h.05c.52-.98 1.8-2.02 3.7-2.02 3.95 0 4.68 2.6 4.68 5.98V22h-4v-5.66c0-1.35-.03-3.08-1.88-3.08-1.88 0-2.17 1.47-2.17 2.98V22h-4V8z" />
                                </svg>

                                <span className="sr-only">LinkDin page</span>
                            </a>
                        </div>
                    </div>
                </div>

            </footer>

        </>
    )
}

export default Footer